import sha256 from "crypto-js/sha256";
import hmacSHA512 from "crypto-js/hmac-sha512";
import Base64 from "crypto-js/enc-base64";

export const hashString = (str: string): string => {
  const hashDigest = sha256(str);
  return Base64.stringify(hmacSHA512(hashDigest, "noKey"));
};
